import { useNavigate } from "react-router-dom";
import { EMPTY_TRAFFIC, TrafficForm, createTraffic } from "./TrafficForm";

export function TrafficNew() {
	const nav = useNavigate();
	return (
		<div className="p-6">
			<h1 className="mb-4 text-xl font-semibold">New traffic profile</h1>
			<TrafficForm
				initial={EMPTY_TRAFFIC}
				submitLabel="Create"
				onSubmit={async (v) => {
					const { id } = await createTraffic(v);
					nav(`/traffic/${id}`, { replace: true });
				}}
				onCancel={() => nav("/traffic")}
			/>
		</div>
	);
}
